<div class="mdc-layout-grid">
  <div class="mdc-layout-grid__inner">
    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
      <div class="loading-animation">
        <planone-loading-animation></planone-loading-animation>
      </div>
    </div>
  </div>
</div>
